"use client"
import classNames from "classnames";
import type { AdProps } from "src/components/ads/AdProps";
import { useAdContext } from "src/lib/types/ads/AdContextType";
import styles from "./KinodkAd.module.css";
import { locale } from "@locale";
import { useEffect, useRef } from "react";

//#region [Component]
export default function KinodkAd({ targetId, className, supportsFixedAd = false, canHide = false, removeIfNoAd = false, height, mobileScreenWidth = false, isPixel = false, noHeader = false, refreshKey, style }: AdProps) {
    const adContext = useAdContext();
    const mobileRef = useRef<HTMLDivElement>(null);
    const desktopRef = useRef<HTMLDivElement>(null);

    const auId = adContext.getAuId(targetId);
    const ids = auId?.split("|") ?? [];
    const [mobileId, desktopId] = ids;

    useEffect(() => {
        if (!auId) return;
        if (mobileRef.current && mobileId?.trim()) mobileRef.current.id = mobileId.trim();
        if (desktopRef.current && desktopId?.trim()) desktopRef.current.id = desktopId.trim();
        adContext.registerAdUnit(targetId);
        return () => {
            adContext?.unregisterAdUnit(targetId);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- register the ad unit once per mount
    }, []);

    if (!auId) {
        console.warn("%cNo auId found for '%s'", "color: white; background: #3e3e48;", targetId);
        return null;
    }

    if (ids.length === 1) {// mobile only adUnit present
        return <div ref={mobileRef} style={style} className={classNames(className, styles.MobileAd)}></div>;
    }

    return <>
        {mobileId?.trim() && <div ref={mobileRef} style={style} data-adheader={locale.ads.adLabel} className={classNames(className, styles.Ad, styles.MobileAd)} data-targetid={targetId}></div>}
        {desktopId?.trim() && <div ref={desktopRef} style={style} data-adheader={locale.ads.adLabel} className={classNames(className, styles.Ad, styles.DesktopAd)} data-targetid={targetId}></div>}
    </>;
}
//#endregion